const tblSingle = {
  55: [4.0,21.00, 20.70],
  56: [5.0,22.00,21.06],
  57: [6.0, 23.00, 21.09],
  58: [7.5, 24.00, 22.86],
  59: [8.5, 25.00, 24.60],
  60: [10.0, 26.00, 23.81],
  61: [11.0, 27.00, 26.40],
  62: [12.0, 28.00, 24.20],
  63: [13.0, 29.00, 23.95],
  64: [14.0, 30.00, 24.89],
  65: [15.5, 31.00, 24.05],
  66: [17.0, 32.00, 25.35],
  67: [18.0, 33.00, 26.65],
  68: [19.0, 34.00, 25.97],
  69: [20.5, 35.00, 28.04],
  70: [22.0, 36.00, 25.43],
  71: [23.0, 37.00, 25.44],
  72: [24.0, 38.00, 23.81],
  73: [24.5, 39.00, 25.59],
  74: [25.0, 40.00, 26.76],
  75: [26.0, 41.00, 25.92],
  76: [26.5, 42.50, 26.81],
  77: [27.0, 43.00, 29.68],
  78: [28.0, 44.00, 25.11],
  79: [29.0, 45.00, 28.53],
  80: [30.0, 46.00, 23.60],
  81: [31.0, 47.00, 25.15],
  82: [32.0, 48.00, 23.48],
  83: [33.0, 49.00, 25.28],
  84: [34.0, 50.00, 27.69]
};

const tblJoint = {
  55: [4.0,21.00, 20.70],
  56: [5.0,22.00,21.06],
  57: [6.0, 23.00, 21.09],
  58: [7.5, 24.00, 22.86],
  59: [8.5, 25.00, 24.60],
  60: [10.0, 26.00, 23.81],
  61: [11.0, 27.00, 26.40],
  62: [12.0, 28.00, 24.20],
  63: [13.0, 29.00, 23.95],
  64: [14.0, 30.00, 24.89],
  65: [15.5, 31.00, 24.05],
  66: [17.0, 32.00, 25.35],
  67: [18.0, 33.00, 26.65],
  68: [19.0, 34.00, 25.97],
  69: [20.5, 35.00, 28.04],
  70: [22.0, 36.00, 25.43],
  71: [23.0, 37.00, 25.44],
  72: [24.0, 38.00, 23.81],
  73: [24.5, 39.00, 25.59],
  74: [25.0, 40.00, 26.76],
  75: [26.0, 41.00, 25.92],
  76: [26.5, 42.50, 26.81],
  77: [27.0, 43.00, 29.68],
  78: [28.0, 44.00, 25.11],
  79: [29.0, 45.00, 28.53],
  80: [30.0, 46.00, 23.60],
  81: [31.0, 47.00, 25.15],
  82: [32.0, 48.00, 23.48],
  83: [33.0, 49.00, 25.28],
  84: [34.0, 50.00, 27.69]
};

const fallBack  = {
  55: [10.0, 12.0],
  56: [11.0, 12.0],
  57: [12.5, 12.5]
};
// const isValid = x => (typeof x !== 'undefined' && x !== null && !isNaN(x));

export const getLtvValue = ({ clientAge, isJoint, housePrice, ltvPlan }) => {
  const age = (clientAge > 90) ? 90 : clientAge;
  const tbl = (isJoint) ? tblJoint[age] : tblSingle[age];

  let fallback = null;

  if(age < 58)
  {
    fallback = fallBack[age]
  }

  let HealthyPreCalc = parseInt( housePrice * 0.01, 10);
  let HealthPreCalcPer = tbl[0];

  //const Healthy = HealthyPreCalc;
  // const Healthy = (housePrice < 1000000) ? 10000 : Math.round(housePrice * 0.01);
  // const HealthyPct = ((((housePrice < 1000000) ? 10000 : Math.round(housePrice * 0.01)) / housePrice) * 100).toFixed(1);
  const Healthy = parseInt( housePrice * 0.01 * tbl[0], 10);
  const Mild = parseInt( housePrice * 0.01 * tbl[1], 10);
  const Moderate = parseInt( housePrice * 0.01 * tbl[2], 10);

  const result = { Healthy, Mild, Moderate };
  result.max = result[ ltvPlan || 'Moderate' ];
  result.diff = result.Moderate - result.Healthy;
  result.pct = { Healthy: tbl[0], Mild: tbl[1], Moderate: tbl[2] };
  return result;
};



// WEBPACK FOOTER //
// ./src/services/LtvCalc.js